<template>
  <modal-form v-model="show" size="md">
    <template v-slot:title>
      <h3 class="modal-title">Análise</h3>
    </template>
    <template v-slot:body>
      <v-row v-if="carregando" class="px-3 py-6" justify="center">
        <v-progress-circular indeterminate color="primary" />
      </v-row>

      <v-row v-else class="px-3 py-2">
        <v-col cols="12" class="mb-2">
          <div class="label-title">Decisão:</div>
          <div class="decisao-box" :class="`decisao-box--${decisao.cor}`">
            <v-icon :color="decisao.cor" class="mr-2">{{ decisao.icone }}</v-icon>
            <span :class="`${decisao.cor}--text`">{{ decisao.text }}</span>
          </div>
        </v-col>

        <v-col v-if="decisao.mensagem" cols="12" class="mb-2">
          <div class="label-title">Detalhes da Decisão:</div>
          <div class="content-text">{{ decisao.mensagem }}</div>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <div class="flex-grow-1"></div>
      <v-btn color="white" @click="closeModal">Cancelar</v-btn>
      <v-btn
        v-if="!isHistorico"
        color="primary"
        variant="flat"
        @click="registrarVisto"
        :disabled="Object.keys(visto).length > 0"
        >Visto</v-btn
      >
    </template>
  </modal-form>
</template>

<script>
export default {
  props: {
    isHistorico: Boolean
  },
  data() {
    return {
      show: false,
      carregando: false,
      model: {},
      onboardingResumo: {},
      analisesComparativo: [],
      visto: {}
    }
  },
  computed: {
    decisao() {
      const th = this

      const valor = th.$api.Functions.ObterDecisaoAnalise(
        th.model.situacaoBmpOrigem,
        th.onboardingResumo,
        th.analisesComparativo
      )

      return th.$api.Arrays.DecisaoAnalise.find(x => x.value === valor)
    }
  },
  methods: {
    async openModal(curr) {
      const th = this

      th.limparCampos()
      th.show = true
      document.addEventListener('keydown', th.handleKeydown)

      Object.assign(th.model, curr)

      if (th.model.situacaoBmpOrigem === null || th.model.situacaoBmpOrigem === undefined)
        await th.obterConsultas()

      if (!th.isHistorico)
        th.visto = (await th.obterVisto()) || {}
    },
    async obterConsultas() {
      const th = this
      th.carregando = true

      try {
        const response = await th.$api.AnalisesOnboarding.ObterConsulta(th.model.codigo)

        if (!th.$api.UI.PostLoadData(response)) return

        Object.assign(th.onboardingResumo, response.resumo)
        Object.assign(th.analisesComparativo, response.comparacao)
      } finally {
        th.carregando = false
      }
    },
    async obterVisto() {
      const th = this

      return th.$api.OnboardingContas.ObterVisto({
        CodigoOnboarding: th.model.codigo,
        TipoInformacao: th.$api.Arrays.TipoInformacao.find(
          t => t.text === 'Bureau'
        ).value
      })
    },
    async registrarVisto() {
      const th = this

      try {
        const dto = {
          CodigoOnboarding: th.model.codigo,
          TipoInformacao: th.$api.Arrays.TipoInformacao.find(
            t => t.text === 'Bureau'
          ).value
        }

        await th.$api.OnboardingContas.RegistrarVisto(dto)

        th.closeModal()
        th.$api.UI.ShowSuccess('Sucesso', 'Visto registrado com sucesso')
      } catch (err) {
        th.$api.UI.ShowError('Erro', 'Erro ao registrar visto')
      }
    },
    limparCampos() {
      const th = this

      th.carregando = false
      th.model = {}
      th.onboardingResumo = {}
      th.analisesComparativo = []
      th.visto = {}
    },
    closeModal() {
      const th = this

      th.limparCampos()
      th.show = false
      th.$emit('close')
      document.removeEventListener('keydown', th.handleKeydown)
    },
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.closeModal()
      }
    }
  }
}
</script>

<style scoped>
.modal-title {
  font-size: 1.25rem;
  font-weight: bold;
  text-align: center;
}

.label-title {
  font-weight: bold;
  color: #333;
  margin-bottom: 0.25rem;
}

.decisao-box {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: bold;
}

.decisao-box--success {
  background-color: #f1f8f2;
  border-color: #c8e6c9;
}

.decisao-box--error {
  background-color: #fdf1f1;
  border-color: #f5c6c6;
}

.decisao-box--warning {
  background-color: #fdf8ee;
  border-color: #f2dfb5;
}

.content-text {
  padding: 0.5rem;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 0.95rem;
  color: #555;
}
</style>
